import { LegalProceedingsFormProps } from './props';
import { useLegalProceedingsForm } from './hook';
import FormView from '../../../../components/views/formView';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { Grid } from '@mui/material';
import { LegalProceedingsProcessData } from './processData';
import { LegalProceedingsProduct } from './product';
import { LegalProceedingsAnnexes } from './annexes';
import { LegalProceedingsAttachment } from './attachment';
import SearchIcon from '@mui/icons-material/Search';

export const LegalProceedingsForm = ({
    showFormView,
}: LegalProceedingsFormProps) => {
    const {
        legalProceeding,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setFormikLegalProceedingProcessData,
        setFormikLegalProceedingProduct,
        setFormikLegalProceedingAnnexes,
        setAttachments,
    } = useLegalProceedingsForm();

    return (
        <>
            {showFormView && (
                <FormView
                    title={
                        legalProceeding && legalProceeding.id
                            ? 'Editar Proceso Judicial'
                            : 'Crear Proceso Judicial'
                    }
                    onClickBack={handleCleanAndBack}
                    labelBack="Buscar"
                    iconBack={<SearchIcon />}
                    variantBack="outlined"
                />
            )}
            <LegalProceedingsProcessData
                data={legalProceeding?.processData}
                onChangeFormik={(formik) =>
                    setFormikLegalProceedingProcessData(formik)
                }
            />
            <LegalProceedingsProduct
                data={legalProceeding?.product}
                onChangeFormik={(formik) =>
                    setFormikLegalProceedingProduct(formik)
                }
            />
            <LegalProceedingsAttachment
                data={legalProceeding?.attachments}
                onChangeData={setAttachments}
            />
            <LegalProceedingsAnnexes
                data={legalProceeding?.annexes}
                onChangeFormik={(formik) =>
                    setFormikLegalProceedingAnnexes(formik)
                }
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                {(!legalProceeding || !legalProceeding.id) && (
                    <LoadingButtonGeneral
                        disabled={loading}
                        title="Volver"
                        variant="outlined"
                        onClick={handleCleanAndBack}
                    />
                )}
            </Grid>
        </>
    );
};
